/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './mask.user.tpl.html';

angular
  .module('shared.mask', [])
  /**
   * Constant used to configure extra cls to be added to image
   * for particular states.
   */
  .constant('STATE_MASK_CLS', {
    'batchMain.batch': 'sbsf-batch-mask-img'
  })
  /**
   * Controller for the mask template.
   */
  .controller('MaskCtrl', function ($scope, $timeout, $state, STATE_MASK_CLS) {
    // scope property used to show the mask
    $scope.showMask = false;
    // var used to apply extra clazz to mask image
    $scope.extraImgCls = '';

    $scope.showMaskHandler = function () {
      $scope.showMask = true;
    };

    // Watch the show trigger scope property that is managed by the parent scope
    // for changes.  When true fire off the timeout to show the mask.  If false
    // clear the mask values including a queued timeout promise to show.
    $scope.$watch('showTrigger', function (newVal) {
      if (newVal) {
        $scope.extraImgCls = STATE_MASK_CLS[$state.current.name];
        $scope.showPromise = $timeout($scope.showMaskHandler, 500);
      } else {
        $scope.showMask = false;
        $timeout.cancel($scope.showPromise);
        $scope.showPromise = undefined;
        $scope.extraImgCls = '';
      }
    });
  })
  /**
   * The directive for the mask view.
   */
  .directive('mask', function () {
    return {
      templateUrl: 'shared/mask/mask.user.tpl.html',
      scope: {
        showTrigger: '=trigger'
      },
      controller: 'MaskCtrl'
    };
  });
